module.exports = __webpack_public_path__ + "img/joagrologo.63ba70a0.jpg";